import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React from "react";
import SalesFunnelItemList from "./components/sales-funnel-item-list";
import { ISaleFunnel } from "src/interface/ISaleFunnel";

const ShowSalesFunnelInfo = ({
  open,
  handleClose,
  saleFunnel,
}: {
  open: boolean;
  handleClose: () => void;
  saleFunnel: ISaleFunnel;
}) => {
  return (
    <React.Fragment>
      <Dialog open={open} onClose={handleClose} maxWidth="xl">
        <DialogTitle>قیف فروش {saleFunnel.title}</DialogTitle>
        <DialogContent>
          <SalesFunnelItemList rows={saleFunnel} />
        </DialogContent>
        <DialogActions>
          <Button color="error" variant="contained" onClick={handleClose}>
            انصراف
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default ShowSalesFunnelInfo;
